import React, { Fragment } from 'react';

import Header from '../components/Header/index';
import Footer from '../components/Footer/index';

const Layout = (props) => {

    return (
        <Fragment>
            <Header />
            {props.children}
            <Footer />
        </Fragment>
    );
}

export default Layout;